import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import jobs from '../jobs';

export default function QuotePage() {
    const [quotes, setQuotes] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        axios.get('api/manage/quotes', { timeout: process.env.REACT_APP_API_TIMEOUT })
            .then((res) => { setQuotes(res.data); })
            .catch((err) => { console.error("견적 요청 목록을 불러오지 못했습니다:", err.message); });
    }, []);

    const handleClick = (id) => { navigate(`/quote/${id}`); };

    const TableHead = ({label}) => {
        return <th style={{ padding: "12px 8px", borderBottom: "2px solid #e1e1e1" }}>{label}</th>;
    }

    const TableRow = ({label}) => {
        return <td style={{ padding: "10px 8px", borderBottom: "1px solid #f0f0f0", textAlign: "center" }}>{label}</td>;
    }

    return (
        <div style={{ maxWidth: 800, margin: "40px auto", fontFamily: "sans-serif" }}>
            <h2 style={{ textAlign: "center", marginBottom: 24 }}>견적 요청 리스트</h2>
            <table style={{ width: "100%", borderCollapse: "collapse", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                <thead>
                    <tr style={{ background: "#f5f6fa" }}>
                        <TableHead label="ID" />
                        <TableHead label="이름" />
                        <TableHead label="업무" />
                        <TableHead label="지역" />
                        <TableHead label="요청일" />
                    </tr>
                </thead>
                <tbody>
                    {quotes.map((item, idx) => (
                        <tr key={item.id} style={{ background: idx % 2 ? "#fafbfc" : "#fff", cursor: "pointer" }} onClick={() => handleClick(item.id)}>
                            <TableRow label={item.id} />
                            <TableRow label={item.name} />
                            <TableRow label={(() => {
                                const a = jobs.find(j => j.key === item.job);
                                return a ? a.label : item.job;
                            })()} />
                            <TableRow label={item.locale} />
                            <TableRow label={new Date(item.createdAt).toLocaleDateString()} />
                        </tr>
                    ))}
                    {quotes.length === 0 && (
                        <tr>
                            <td colSpan={5} style={{ textAlign: "center", color: "#888", padding: 24 }}>견적 요청 내역이 없습니다.</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}